<template>
    <div class="stepsDetailX">
        <div id="amapContainer" style="width:100vw;height:100vh;"></div>
        <div class="notice">
          <van-notice-bar
              color="#ffffff" background="rgba(0,0,0,.3)"
              left-icon="volume-o"
              text="地图非真实比例地图，详细地址见点位信息。"
          />
        </div>

        <div class="header">
            <van-image :src="userInfo.userInfo.avatarurl"></van-image>
            <span>
            <ICountUp :endVal="userTaskInfo.totalSteps*1"/>
         </span>
         <span>自  {{userTaskInfo.join_start_time}}起累计</span>
        </div>
        <div class="star"><img src="https://oss.mcloud.moveclub.cn/mpms/20210625/1624591665-60d54d3159896.png" alt=""></div>
        <div class="rules" @click="rulesShow=true">
            <img src="@/assets/img/steps/tiku.png" alt/>
        </div>
        <div class="footer">
            <div>
                <span>{{userTaskInfo.currentFinished}}</span>
                已点亮点位
            </div>
            <div @click="handleSteps" v-if="userTaskInfo.currentFinished<point.length">
                <a>点亮</a>
            </div>
            <div @click="getcard" v-else>
              <a style="font-size:.4rem;">
                下载
                <br/>证书
              </a>
            </div>

            <div>
                <div>
                    <span>{{freenum}}</span>
                    抽奖机会
                </div>
                <img src="@/assets/img/steps/draw.png" alt @click="goluckdraw"/>
            </div>
        </div>

        <van-dialog
                v-model="rulesShow"
                title="活动题库"
                :style="{width:'80vw' }"
                round
                close-on-click-overlay
        >
            <div style="padding:0rem;overflow: scroll;height:40vh;" v-html="detail.intro"></div>
        </van-dialog>

        <Popup
                v-model="pointShow"
                get-container="#app"
                :style="{ width: '6.74rem',overflowY:'inherit' }"
                round
                close-on-click-overlay
        >
            <div :class="['pointDesc',activityPoints.playerInfo == null||activityPoints.playerInfo == ''?'isfalse':'']">
                <div class="img"><img style="width: 6.17rem;height: 3.36rem;border-radius:.1rem;" :src="activityPoints.shortdesc" alt=""></div>
                <div class="headertitle">{{activityPoints.title}}</div>
                <div class="p-address"><img style="width: .2rem;height: .29rem" src="https://oss.mcloud.moveclub.cn/mpms/20210618/1624015360-60cc8200e5e77.png" /><span>地址：{{activityPoints.address}}</span></div>
                <div class="intro" v-if="activityPoints.description">
                  <div class="introtitle">
                    点位介绍
                  </div>
                  <div :style="{display:showMore?'block':'-webkit-box'}"><div v-html="activityPoints.description"></div></div>
                  <van-icon name="arrow-down" color="#999" @click="showMore=true" v-if="!showMore && activityPoints.description.length>=40"/>
                  <van-icon name="arrow-up" color="#999" @click="showMore=false" v-if="showMore && activityPoints.description.length>=40"/>
                </div>

                <footer style="margin-top:10px;color:#393940;font-size: .3rem;"
                        v-if="activityPoints.msg && activityPoints.futurecan*1">
                  您还可以继续点亮 <span style="color: #FF5D4B">{{activityPoints.futurecan}}</span>个地标<br>是否继续点亮?
                </footer>

                <div class="button" @click="handleQus" v-if="!activityPoints.hasanswer&&activityPoints.playerInfo != null">请先答题</div>

                <div  style="color:#999;font-size: .3rem;margin-top:10px;"  @click="closepointShow">
                  取消
                </div>
            </div>
        </Popup>
      <Popup
          v-model="answershow"
          get-container="#app"
          :style="{ width: '80%' }"
          round
          close-on-click-overlay
          @closed="onCloseP"
      >
        <div class="answerDetail">
          <div id="fireworks" v-if="drawshow">
            <img src="@/assets/img/steps/fire/1.png" alt="">
            <img src="@/assets/img/steps/fire/2.png" alt="">
            <img src="@/assets/img/steps/fire/3.png" alt="">
            <img src="@/assets/img/steps/fire/4.png" alt="">
            <img src="@/assets/img/steps/fire/5.png" alt="">
          </div>
          <div class="title">
            选择正确的答案
            完成地标点亮
          </div>
          <div class="qu_list">
            <div class="qu_t">{{question.title}}</div>
            <van-radio-group v-model="check" :disabled="drawshow" @change="radioChange">
              <van-radio class="qu_item" v-for="(item,index) in question.content" :key="item.value" :name="index">{{lettersarr[index]}}. {{item}}</van-radio>
            </van-radio-group>

          </div>
          <div class="btn">
            <div v-if="!answererror" :class="['button',drawshow?'isfalse':'']" @click="handleAnswer">答题</div>
            <div v-else class="button" @click="contue">继续下一题</div>

            <div  style="color:#999;font-size: .3rem;margin-top:10px;text-align: center;"  @click="onCloseP">
              关闭
            </div>
          </div>
        </div>
      </Popup>
    </div>
</template>
<script>
    var points = [[[403,139], [403,255]],
      [[403,255], [546,255]],
      [[546,255], [546,367]],
      [[546,367], [233,367]],
      [[233,367], [233,454]],
      [[233,454], [475,454]],
      [[475,454], [475,301]],
      [[475,301], [326,301], [326,591]],
      [[326,591], [561,591]],
      [[561,591], [561,504], [380,504]],
      [[380,504], [380,648]],
      [[380,648], [178,648]],
      [[178,648], [178,499]],
      [[178,499], [256,499]],
      [[256,499], [256,741]],
      [[256,741], [315,741], [315,704], [432,704]],
      [[432,704], [432,670], [494,670]],
      [[494,670], [494,772]],
      [[494,772], [466,772], [466,831], [305,831]],
      [[305,831], [305,786], [418,786], [418,908]],
      [[418,908], [520,908],[520,985]],[[520,985],[520,1185]]];
    for(var i = 0;i<points.length;i++){
      for(var j = 0;j<points[i].length;j++){
        points[i][j][0] = (points[i][j][0] - 335)*0.000004487*10 + 121.493356
        points[i][j][1] = ((1204-points[i][j][1]) - 535)*0.000003457*10 + 31.200089
      }
    }
    var offset = [
        [10, -55], //1
        [-60, -85], //2
        [-95, -40],//3
        [-80, -50],//4
        [-30, -80],//5
        [-25, -85],//6
        [10, -45],//7
        [0, -50],//8
        [-80, -50],//8
        [10, -50],//10
        [0, 0],//11
        [-55, 10],//12
        [-30, 0], //13
        [-30, 10],  //14
        [-50, 15], //15
        [-60, 0],
        [-90, -50],
        [0, -20],
        [-90, -30],
        [-10, 0],
        [-50, -50],
    ];
    var offset14 = [
        [0, -50], //1
        [-30, -65], //2
        [-70, -20],//3
        [-60, -30],//4
        [-20, -60],//5
        [-25, -65],//6
        [10, -45],//7
        [10, -30],//8
        [-50, -30],//9
        [20, -30],//10
        [0, 0],//11
        [-55, 10],//12
        [-20, 10], //13
        [-30, 10],  //14
        [-35, 5], //15
        [-40, 0],
        [-60, -30],
        [5, -10],
        [-60, -20],
        [-5, 5],
        [-30, -30],
    ];


    var arr = [];
    import {mapGetters} from "vuex";
    import PinchZoom from "vue-pinch-zoom";
    import {Button, Image, Loading, Swipe, SwipeItem, Popup, Collapse, CollapseItem, NoticeBar, RadioGroup, Radio} from "vant";
    import Footbar from "@/components/footbar/index";
    import ICountUp from "vue-countup-v2";
    import {lazyAMapApiLoaderInstance} from "vue-amap";
    import moment from 'moment';
    // import VConsole from 'vconsole'

    const STEPS_COUNT = 8000;
    const JACKPOT = 919;
    export default {
        name: "checkDetail",
        computed: {
            ...mapGetters({
                userInfo: "getUserInfo"
            })
        },
        data() {
            return {
                // userInfo: {
                //   userInfo: {
                //     address: "",
                //     avatarurl: "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJJCPmOBLhIzmHNvb9rKMMk64tyhPXnK0YdluvfwwicAUeicbZGIGLoxFzW0CWMueZl5uoTdp3ThMtw/132",
                //     city: "",
                //     continue_sign: 0,
                //     continue_signin_score: 20,
                //     country: "China",
                //     coupon_count: "0",
                //     create_time: 1564628229,
                //     enurid: "ODRaK2pTbEdDVW89",
                //     gender: 1,
                //     grand_total_point: 0,
                //     id_number: "341182***4459",
                //     id_type: null,
                //     issignin: 0,
                //     language: "zh_CN",
                //     name: "李响",
                //     nickname: "Li.",
                //     openid: "oC8Xn5fDCAqyYccwapEjfM5VT964",
                //     phone: "15858214461",
                //     province: "",
                //     role: 0,
                //     signin_score: 0,
                //     status: 1,
                //     total_point: 0,
                //     totalpoint: 0,
                //     update_time: "2021-06-23 22:01:59",
                //     urid: 4848
                //   }
                // },
                showMore:false,
                activityPoints:{},
                collapsename: [],
                hasques: false,
                point: [],
                pointShow: false,
                pointShowFrom: 1,
                rulesShow: false,
                userTaskInfo: {
                    currentFinished: 0,
                    totalSteps: 0
                },
                sigining: false,
                freenum: 0,
                detail: {},
                markers:[],
                markers14:[],
                systime: '',
                answershow: false,
                lettersarr: [
                  "A",
                  "B",
                  "C",
                  "D",
                  "E",
                  "F",
                  "G",
                  "H",
                  "I",
                  "J",
                  "K",
                  "L",
                ],
                question: {},
                answer: [],
                bind_subid: '',
                drawshow: false,
                answererror: false,
                check: '',
                finished: 0
            };
        },
        components: {
            Button,
            VanImage: Image,
            Footbar,
            Loading,
            Swipe,
            SwipeItem,
            ICountUp,
            Popup,
            PinchZoom,
            Collapse,
            CollapseItem,
            VanNoticeBar:NoticeBar,
          VanRadioGroup:RadioGroup,
          VanRadio:Radio
        },
        methods: {
          handleQus() {
            let list = this.point
            let  res = list.find(item => item.hasanswer == 0&&item.playerInfo != null)
            if(res){
              this.getques()
              this.answershow = true
              this.bind_subid = res.id
              this.answer = []
              this.check = ''
            }
          },
          onCloseP() {
            this.answer = []
            this.question = {}
            this.bind_subid = ''
            this.check = ''
            this.pointShow = false
            this.answershow = false
            this.drawshow = false
            this.pointShowFrom = 1;
            this.getTaskList();
          },
          contue() {
            this.answererror = false
            this.getques()
            this.answer = []
            this.question = {}
            this.check = ''
          },
          handleAnswer:function (){
            if(this.answer.length==0){
              this.$toast('请选择回答后再提交')
              return;
            }
            if(this.answer[0].answer != this.question.answer){
              this.$toast('答错啦，正确答案是'+this.question.content[this.question.answer-1])
              this.answererror = true
              return;
            }

            this.$api.answer.submitQuestions({ aid:this.detail.relation_actvity_id,answer:JSON.stringify(this.answer),bind_subid:this.bind_subid })
                .then((res) => {
                  if (res.status * 1 === 200) {
                    let num = this.point.length
                    if(this.finished === num && this.point[num-1].id*1 === this.bind_subid*1){
                      this.$toast('恭喜完赛，点击下载证书按钮查看证书')
                    }else{
                      this.$toast({message:'恭喜您答对并点亮该点位，点击“关闭”按钮继续',duration:4000})
                    }
                    this.drawshow = true
                    this.getTaskList();
                  }
                })
          },
          radioChange(e){
            this.answer = []
            let select = e*1 + 1
            this.answer.push({
              qid: this.question.qid,
              answer: select,
            })
          },
            getcard() {
              this.$api.activity
                  .getCert({id: this.$route.params.activity_id})
                  .then(res => {
                    wx.previewImage({
                      urls: [res.data.cert]
                    });
                  });
              return;
            },
            getques() {
              this.$api.answer.questions({aid:this.detail.relation_actvity_id}).then((res)=>{
                this.question = res.data.questions.length>0?res.data.questions[0]:[]
              })
            },
            handleSteps() {
                let that = this
                var timestamp = this.systime;
                var starttime = this.detail.start_time*1
                // var endtime = this.detail.end_time*1
                if(timestamp<starttime){
                  this.$toast('还未开始，请耐心等待');
                  return;
                }
                let list = this.point
                let  res = list.find(item => item.hasanswer == 0&&item.playerInfo != null)
                if(res){
                  this.getques()
                  this.answershow = true
                  this.bind_subid = res.id
                  this.answer = []
                  return
                }
                this.$toast.loading("处理中...");
                this.$api.steps.stepsCheckin(Object.assign({api_throw_exception: false}, this.$route.params)).then(
                   async res => {

                        this.sigining = false;
                        this.$toast.clear();
                        if (+res.status !== 200) {
                            this.$toast({
                                type: 'html',
                                position: "bottom",
                                message: "<div style='display: flex;align-items: center;font-size:12px;'>" +
                                    "<img src='" + require("@/assets/img/steps/run.png") + "' style='width:.44rem;height:.44rem;margin-right: 5px;'>" + res.message + "</div>",
                                duration: 5000,
                                className: "bottomToast"
                            })

                            return;
                        }

                      var ret = await that.getActivityNew()
                      if(ret.status === 200){
                        var {finided,betweenSteps}  = res.data
                        var subList = ret.data.subList
                        var item = subList.find(row => row.id === finided.id)
                        finided.hasanswer = item.hasanswer
                        finided.playerInfo = item.playerInfo
                        that.activityPoints = finided
                        if (!that.pointShow) that.pointShow = true;
                        that.userTaskInfo.totalSteps = betweenSteps;
                      }
                      this.getTaskList();
                      this.activityDetail();
                    },
                    () => {

                    }
                );
            },

            getActivityNew() {
              let that = this;
              return new Promise((resolve, reject) => {
                this.$api.activity.taskList(that.$route.params).then(res => {
                  if (res.status === 200) {
                    let {subList} = res.data;
                    let finished = 0;
                    //解析url 参数
                    try {
                      subList.forEach((item) => {
                        if (item.playerInfo != null) {
                          finished++
                        }
                      })
                    } catch (e) {

                    }
                    that.point = subList
                    that.finished = finished
                    resolve(res)
                  }else{
                    resolve(res)
                  }
                });
              })

            },

            getTaskList() {
                let that = this;
                new Promise(function (resolve, reject) {
                    //先清除所有的marker
                    that.map.remove(that.markers14)
                    that.map.remove(that.markers);
                    that.$api.activity.taskList(that.$route.params).then(res => {
                        if (res.status * 1 === 200) {
                            var {subList, intro, title, relation_actvity_id, relation_activity_type} = res.data;
                            var currentFinished = 0;

                            var finshedLine = [];
                            var finshedfirstpoint = [];
                            var markers = [];
                            var markers14 = [];

                            if(relation_actvity_id != ''&&relation_activity_type==5){
                              that.hasques = true
                            }

                            subList.forEach((item, index) => {
                                if (!!item.playerInfo&&item.hasanswer) {
                                    currentFinished++;
                                    var icon = new AMap.Icon({
                                        size: new AMap.Size(57, 70),    // 图标尺寸
                                        image: item.imgurl,
                                        imageSize: new AMap.Size(57, 70),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon, // 添加 Icon 实例
                                        offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker.on('click', function (e) {
                                        that.markerClick(e)
                                    })


                                    var icon14 = new AMap.Icon({
                                        size: new AMap.Size(30,37),    // 图标尺寸
                                        image: item.imgurl,
                                        imageSize: new AMap.Size(30,37),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker14 = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon14, // 添加 Icon 实例
                                        offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker14.on('click', function (e) {
                                        that.markerClick(e)
                                    })


                                    var content = '<div class="first-pointx activity">' + (index+1) + "</div>";
                                    finshedfirstpoint.push(
                                        new AMap.Marker({
                                            position: points[index][points[index].length - 1],
                                            content,
                                            offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                            anchor: 'bottom-left', // 设置锚点方位
                                            zooms: [14,16],
                                            zoom: 15,
                                        })
                                    );
                                    finshedLine = finshedLine.concat(points[index])
                                  if(currentFinished==21){
                                    finshedLine = finshedLine.concat(points[index+1])
                                  }
                                } else {
                                    var icon = new AMap.Icon({
                                        size: new AMap.Size(49, 63),    // 图标尺寸
                                        image: item.icon,
                                        imageSize: new AMap.Size(49, 63),   // 根据所设置的大小拉伸或压缩图片
                                    });

                                    var marker = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon, // 添加 Icon 实例
                                        offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                        anchor: 'center', // 设置锚点方位
                                        title: index,
                                        zooms: [14,16],
                                        zoom: 15,
                                        zIndex:999

                                    });

                                    AMap.event.addListener(marker,'click',that.markerClick);

                                    marker.on('click', function (e) {
                                        that.markerClick(e)
                                    })



                                    var icon14 = new AMap.Icon({
                                        size: new AMap.Size(30, 39),    // 图标尺寸
                                        image: item.icon,
                                        imageSize: new AMap.Size(30, 39),   // 根据所设置的大小拉伸或压缩图片
                                    });
                                    var marker14 = new AMap.Marker({
                                        position: points[index][points[index].length - 1],
                                        icon: icon14, // 添加 Icon 实例
                                        offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                        anchor: 'bottom-left', // 设置锚点方位
                                        title: index,
                                        zIndex:1000
                                    });

                                    marker14.on('click', function (e) {
                                        that.markerClick(e)
                                    })
                                }
                                markers.push(marker);
                                markers14.push(marker14);
                            });
                            // 已经完成的创建折线实例
                            if(finshedLine.length>0){
                                var polyline = new AMap.BezierCurve({
                                    path: finshedLine,
                                    lineJoin: "round",
                                    lineCap: "round",
                                    strokeWeight: 1,
                                    strokeColor: "#FFFFFF",
                                    outlineColor: "#FF5D51",
                                    borderWeight: 4,
                                    isOutline: true,
                                    strokeStyle: "dashed"
                                });
                                polyline.setMap(that.map)
                            }

                            that.markers = markers;
                            that.markers14 = markers14;

                            var zoom = that.map.getZoom()
                            if(zoom==14){
                                that.map.add(markers14)
                            }else{
                                that.map.add(markers);
                            }
                            that.map.add(finshedfirstpoint);
                            that.point = res.data.subList;
                            that.detail = res.data;
                            that.systime = res.timestamp
                            that.userTaskInfo.currentFinished = currentFinished;
                            that.userTaskInfo.join_start_time = moment(res.data.start_time*1000).format('MM月DD日');
                            let index = currentFinished - 1 <= 0 ? 0 : currentFinished - 1
                            index = index + 1 >= 20 ? 20 : (index + 1)
                            that.map.setCenter(
                                points[index][0]
                            );
                            resolve(Object.assign(res.data, {currentFinished}));
                        }
                    });
                }).then(e => {
                    let {start_time, end_time} = e;
                    that.$api.steps.stepsInfo({start_time, end_time}).then(res => {
                        if (+res.status === 200) {
                            let totalSteps = +res.data;
                            this.userTaskInfo = Object.assign(this.userTaskInfo, {
                                totalSteps
                            });
                        }
                    });
                });
            },
            activityDetail: function () {
                this.$api.activity.activityDetail({acid: JACKPOT}).then(res => {
                    this.freenum = res.data.freenum;
                });
            },
            goluckdraw: function () {
                this.$router.push({name: "luckdraw", params: {acid: JACKPOT}});
            },
            markerClick: function (e) {
              console.log(e.target.getTitle(),111)
                if(+e.target.getTitle()===21 && this.userTaskInfo.currentFinished<22){

                    this.$dialog.alert({
                        title: '提示',
                        width:'80vw',
                        message: '您还未走完本次活动的其他点位。\r\n完成所有任务后可查看该点位详情！',
                    }).then(() => {
                        // on close
                    });
                    return ;
                }


                this.activityPoints = this.point[e.target.getTitle()];
                this.pointShow = true;
                this.pointShowFrom = 2;
            },
            closepointShow: function () {
                this.pointShowFrom = 1;
                this.collapsename = []
                this.activityPoints= {}
              this.pointShow = false;
            }
        },
        mounted() {
          // new VConsole()
            // this.$nextTick(() => {
            lazyAMapApiLoaderInstance.load().then(() => {
                var imageLayer = new AMap.ImageLayer({
                    url: "https://oss.mcloud.moveclub.cn/mpms/20210625/1624591225-60d54b794e853.png",
                    bounds : new AMap.Bounds(
                        [121.47231197,31.1710502], [121.51942547,31.229321392]
                    ),
                    zooms: [14,16],
                    zoom: 14,
                    opacity:.5
                });
                let layer_std = new AMap.TileLayer();
                this.map = new AMap.Map("amapContainer", {
                    resizeEnable: true,
                    center: [121.493356,31.200089],
                    zooms: [14,16],
                    zoom: 14,
                    layers: [layer_std, imageLayer],
                    mapStyle: "amap://styles/whitesmoke",
                });

                this.map.remove(layer_std);
                var linePoint = [];
                var firstPointMarkers = [];
                points.forEach((item, index) => {
                    linePoint = linePoint.concat(item);
                    var content = '<div class="first-pointx">' + index + "</div>";
                    if (index) {
                        firstPointMarkers.push(
                            new AMap.Marker({
                                position: item[0],
                                content,
                                animation:"AMAP_ANIMATION_DROP",
                                offset: new AMap.Pixel(-12.5,5), //设置偏移量
                                anchor: 'bottom-left', // 设置锚点方位
                            })
                        );
                    }

                });
             //限制范围
                var bounds = new AMap.Bounds(
                    [121.472521,31.175198], [121.521464,31.23153]
                )
                this.map.setLimitBounds(bounds);
                this.map.add(firstPointMarkers);
                var that = this;
                setTimeout(() => {
                    var polyline = new AMap.BezierCurve({
                        path: linePoint,
                        lineJoin: "round",
                        lineCap: "round",
                        strokeWeight: 1,
                        strokeColor: "#FFFFFF",
                        outlineColor: "#999999",
                        borderWeight: 4,
                        isOutline: true,
                        strokeStyle: "dashed"
                    });
                    polyline.setMap(that.map)
                    that.getTaskList();
                    that.activityDetail();
                }, 1)

                this.map.setFeatures("building")

                this.map.on("click",function (e) {
                    console.log(e);
                })

                this.map.on('zoomend',function (e) {
                    var zoom = that.map.getZoom()
                    if(zoom==14){
                        that.map.remove(that.markers);
                        that.map.add(that.markers14)
                    }else{
                        that.map.remove(that.markers14)
                        that.map.add(that.markers);
                    }

                })



            });

            // })

        }
    };
</script>
<style lang="less">
    @import "Detail.less";
</style>
